import React from "react";

const ScoreDescription = ({ data, index }) => {
  return (
    <div className="mb-4">
      {data[index] && (
        <div dangerouslySetInnerHTML={{ __html: data[index]["info"] }} />
      )}
    </div>
  );
};

export default ScoreDescription;
